import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Container, Row, Col, CardDeck, Card } from "react-bootstrap"
import SignUpComponent from "../../components/sign-up"

const NewsPocamLaunchesSixthVisibleVocal = ({ location }) => {
  return (
    <Layout>
      <SEO
        location={location}
        image="/images/pocam-white-bg.png"
        title="POCAM launches sixth edition of Visible & Vocal study on the BIPOC experience in advertising and marketing"
        description="People of Colour in Advertising and Marketing (POCAM) has launched the sixth edition of Visible & Vocal, the only national industry study focused exclusively on the experiences of Black, Indigenous and People of Colour (BIPOC) professionals in Canada’s advertising, marketing, communications, and creative sectors."
      />
      <section className="bg-dark text-white py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="8">
              <h1 className="display-4 mb-3">POCAM launches sixth edition of Visible & Vocal study on the BIPOC experience in advertising and marketing</h1>
              <h2 className="mb-0">
                <em>For agencies and brands, the findings serve as a mirror of progress and a benchmark for accountability.</em>
              </h2>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="10">
              <p>
                <strong>November 10, 2025</strong> – People of Colour in Advertising and Marketing (POCAM) has launched the sixth edition of <a href="https://www.surveymonkey.com/r/visibleandvocal6" rel="noreferrer" target="_blank">Visible & Vocal</a>, the only national industry study focused exclusively on the experiences of Black, Indigenous and People of Colour (BIPOC) professionals in Canada’s advertising, marketing, communications, and creative sectors.
              </p>
              <p>
                The study invites BIPOC professionals across Canada to share perspectives on workplace culture, representation, discrimination, mentorship, and progress toward equity and inclusion. The survey is completely anonymous and results will be released publicly in early 2026.
              </p>
              <p>
                “Each year, Visible & Vocal makes the invisible visible, revealing truths the industry often tries to overlook,” says POCAM Co-Founder and Board Member Julian Franklin. “We’re not just collecting data with this study. We’re documenting lived experiences and amplifying BIPOC voices to provide evidence for measurable and meaningful change.”
              </p>
              <p>
                Launched in 2020, the same year POCAM was founded, Visible & Vocal has become a trusted benchmark for understanding systemic inequities and emerging trends affecting BIPOC professionals. Findings from last year revealed declining diversity and inclusion in many organizations as microaggressions, bias, and discrimination persisted.
              </p>
              <p>
                While 56% of respondents believed their employer was making positive steps to focus on inclusion and advancement of BIPOC professionals, only 43% indicated that BIPOC professionals were hired into executive positions in the past 12 months and an alarming 58% reported experiencing racial discrimination from a colleague.
              </p>
              <p>
                “This is the only industry study created by BIPOC professionals, for BIPOC professionals,” Franklin added. “Last year’s results demonstrated that executive entry was declining while explicit discrimination increased and community mentorship rose to an all-time high. While industry progress is not guaranteed, truth-telling creates accountability.”
              </p>
              <p>
                BIPOC professionals currently working in Canada’s marketing, advertising, communications, and creative sectors are encouraged to take the survey at: <a href="https://www.surveymonkey.com/r/visibleandvocal6" rel="noreferrer" target="_blank">https://www.surveymonkey.com/r/visibleandvocal6</a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pb-4 pb-lg-5">
        <Container>
          <Row>
            <Col md="10">
              <h3>About POCAM</h3>
              <p>
                Founded in 2020, People of Colour in Advertising and Marketing (POCAM) is a not-for-profit industry organization on a mission to empower BIPOC advertising and marketing professionals to succeed within a systematically white working environment. POCAM is led by a volunteer Steering Committee of BIPOC leaders who devote their time, talent and thought to advocating for equity and inclusion across the industry. The current Steering Committee is composed of Ishma Alexander-Huet, Gavin Barrett, Natalie Bomberry, Erik dela Cruz, Joycelyn David, Deyra Jaye Fontaine, Julian Franklin, Aleena Mazhar, Chino Nnadi, Mark Rutledge, Ken Saint Eloy, Justin Senior, and Matthew Tsang.
              </p>
              <p>
                For more information, visit <Link to="/">WeArePOCAM.ca</Link>.
              </p>
              <br/>
            </Col>
          </Row>

          <Row>
            <Col md="10">
              <h3>Media contact</h3>
              <p>
                For all media inquiries, please contact:
              </p>
              <p>
                POCAM Steerco<br/> 
                <a href="mailto:steerco@wearepocam.ca" rel="noreferrer" target="_blank">steerco@wearepocam.ca</a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <SignUpComponent />
    </Layout>
  )
}

export default NewsPocamLaunchesSixthVisibleVocal